import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import WorkPageHeader from '../../components/work/WorkPageHeader';
import { Card } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import AutoRepliesCard from '../../components/live-chat/AutoRepliesCard';

const LiveChatAutoReplies = () => (
  <MainLayout>
    <div style={{ fontFamily: 'CustomFont' }}>
      <Card className="shadow-xl border-0 work-page-card" styles={{ body: { padding: 0 } }}>
        <WorkPageHeader title="پاسخ خودکار" subtitle="پاسخ خودکار به کامنت‌های اینستاگرام بر اساس کلمه" icon={RobotOutlined} />
        <div className="px-6 pb-6 work-page-body rounded-b-xl">
          <AutoRepliesCard />
        </div>
      </Card>
    </div>
  </MainLayout>
);

export default LiveChatAutoReplies;
